<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                class="koiote_logo"
                color="white"
              >
                <v-toolbar-title>
                  <v-img
                    alt="logo koiote"
                    width="120"
                    src="@/assets/complete_logo.png"
                    transition="scale-transition"
                  />
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text class="text-center">
                <span class="display-1 font-weight-bold">Iniciar Sesión</span>
                <v-form class="mt-6">
                  <!-- <v-text-field
                    prepend-inner-icon="mdi-domain"
                    name="cif"
                    label="CIF"
                    type="text"
                    :rules="[(v) => !!v || 'Rellene el CIF']"
                    v-model="userInfo.cif"
                  ></v-text-field> -->
                  <v-text-field
                    prepend-inner-icon="mdi-account"
                    name="username"
                    label="Usuario"
                    type="text"
                    :rules="[(v) => !!v || 'Rellene el usuario']"
                    v-model="userInfo.username"
                  ></v-text-field>
                  <v-text-field
                    prepend-inner-icon="mdi-lock"
                    id="password"
                    name="psw"
                    label="Contraseña"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    v-model="userInfo.password"
                    :rules="[(v) => !!v || 'Rellene la contraseña']"
                  ></v-text-field>
                </v-form>
                <!-- {{ userInfo }} -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="4"
                  class="mb-2 mr-3"
                  color="primary"
                  outlined
                  @click="logInApp"
                  >Entrar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <v-dialog
      v-model="dialog"
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-alert type="error">
        <v-row
          align="center"
          no-gutters
        >
          <v-col class="grow">
            {{ error_text }}
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col class="shrink">
            <v-btn
              outlined
              @click="dialog = false"
            >
              Volver a intentar
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>
    <Keypress
      key-event="keydown"
      :key-code="13"
      @success="logInApp"
    />
  </v-app>
</template>
<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      userInfo: {
        cif: "A31010788",
        username: "",
        password: "",
      },
      showPassword: false,
      dialog: false,
      error_text: "",
    };
  },
  computed: {
    ...mapState(["all_articles"]),
  },
  components: {
    Keypress: () => import("vue-keypress"),
  },
  computed: {
    ...mapState(['idCliente' , 'esRamos'])
  },
  methods: {
    ...mapActions(["postDataWithReturn","setClientId", "storeToken", "storeUser","storeIdCliente", "storePartnerId", "storePermisos","setAllArticles", "setOrders", "getData","storeRol","setEsRamos","setClientes"]),
    async logInApp() {
      if (this.userInfo.cif != "" && this.userInfo.username != "" && this.userInfo.password != "") {
        try {
          const respuesta = await this.postDataWithReturn({path: "django/portal/login/", body: this.userInfo});

          const { token, id_cliente, id_usuario, rol, partner_id, permisos } = respuesta;

          // 1. Guardar estado básico
          this.setEsRamos(id_cliente == 2000);
          this.storeToken(token);
          this.storeUser({id: id_usuario });
          this.storeRol(rol);
          this.storePermisos(permisos)
          // this.setClientId(id_cliente);
          this.storePartnerId(partner_id);

          // 2. Si es Ramos, cargamos su lista de clientes para los selectores
          if (this.esRamos) {
            const clientes = await axios.post(`/api/django/portal/clientes/`);
            this.setClientes(clientes.data.clientes);
          } else {
            //recogemos los articulos respectivos a la empresa si no es ramos
            this.setClientId(id_cliente);
            if (["developer", "shop"].includes(rol))
              this.getArticles(partner_id);
          }

          // 3. Redirección simple: Si hay QR, vamos a armarios solo con el QR
          if (permisos.length == 0) this.$router.push({ name: 'sin-permiso' });
          else{
            const qrEnUrl = this.$route.query.qr;
            if (qrEnUrl) {
              this.$router.push({ name: "cabinets", query: { qr: qrEnUrl } });
            } else {
              if(permisos.includes('partes')) this.$router.push({ name: 'home' });
              else if(permisos.includes('cabinets')) this.$router.push({ name: 'cabinets' });
              else if(permisos.includes('mantenimiento')) this.$router.push({ name: 'mantenimiento' });
              else if(permisos.includes('piezas')) this.$router.push({ name: 'piezas' });
              else if(permisos.includes('articles')) this.$router.push({ name: 'articles' });
            }
          }
        } catch(error) {
          console.error(error);
          this.error_text = "Usuario o contraseña incorrectos";
          this.dialog = true;
        }
      }
    },
    async getArticles(partner_id) {
      if (!this.all_articles?.length && partner_id != null) {
        // partner_id = 70 //borrar
        const { artículos: articles } = await this.postDataWithReturn({ path: "django/portal/articulos/", body: { partner_id: partner_id } });
        const { orders } = await this.getData({ path: `django/portal/get_orders/?partner_id=${partner_id}` });

        this.setAllArticles(articles.map((a) => ({ quantity: a.qty_available > 0 ? 1 : 0, in_cart: false, note: a.qty_available > 0 ? false : true, ...a })));
        this.setOrders(orders);
      }
    }
  },
};
</script>
